import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getDiningBySlug, dining } from '../data/dining';
import { PageBanner } from '../components/PageBanner';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { KeyDetailsBlock } from '../components/KeyDetailsBlock';
import { ImageGallery } from '../components/ImageGallery';
import { RelatedPages } from '../components/RelatedPages';
import { DownloadCard } from '../components/DownloadCard';
export function DiningDetail() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const outlet = slug ? getDiningBySlug(slug) : undefined;
  if (!outlet) return <Navigate to="/dining" replace data-id="element-755" />;
  const otherOutlets = dining.filter(d => d.id !== outlet.id).slice(0, 3).map(d => ({
    title: d.name,
    image: d.image,
    link: `/dining/${d.id}`
  }));
  return <div className="w-full bg-club-canvas pb-24" data-id="element-756">
      <PageBanner title={outlet.name} eyebrow={outlet.type} image={outlet.image} data-id="element-757" />

      <div className="max-w-7xl mx-auto px-4 mt-8" data-id="element-758">
        <Breadcrumbs items={[{
        label: 'Dining',
        path: '/dining'
      }, {
        label: outlet.name
      }]} data-id="element-759" />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mt-8" data-id="element-760">
          <div className="lg:col-span-2 space-y-12" data-id="element-761">
            <section data-id="element-762">
              <h2 className="text-3xl mb-6" data-id="element-763">Overview</h2>
              <p className="text-lg text-club-ink/80 leading-relaxed" data-id="element-764">
                {outlet.longDesc}
              </p>
            </section>

            <section data-id="element-765">
              <h2 className="text-3xl mb-6" data-id="element-766">Menus</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-767">
                <DownloadCard title="A La Carte Menu" type="PDF" size="1.2 MB" data-id="element-768" />
                <DownloadCard title="Wine & Beverage List" type="PDF" size="2.5 MB" data-id="element-769" />
                {outlet.id === 'the-godavari-room' && <DownloadCard title="Tasting Menu" type="PDF" size="0.8 MB" data-id="element-770" />}
              </div>
            </section>

            <section data-id="element-771">
              <h2 className="text-3xl mb-6" data-id="element-772">Gallery</h2>
              <ImageGallery images={outlet.images} data-id="element-773" />
            </section>
          </div>

          <div className="space-y-8" data-id="element-774">
            <KeyDetailsBlock details={outlet.keyDetails} data-id="element-775" />

            <div className="bg-club-green text-white p-8 rounded-sm text-center" data-id="element-776">
              <h3 className="font-serif text-2xl mb-4" data-id="element-777">Reservations</h3>
              <p className="text-sm text-white/80 mb-6" data-id="element-778">
                We recommend booking in advance to secure your preferred time.
              </p>
              <button className="btn-gold w-full mb-4" data-id="element-779">Book a Table</button>
              <p className="text-xs text-white/60" data-id="element-780">
                Or call +44 (0) 20 7123 4569
              </p>
            </div>
          </div>
        </div>

        <RelatedPages title="More Dining Options" pages={otherOutlets} data-id="element-781" />
      </div>
    </div>;
}